/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersUpdateBySecretariat } from '../../models/members-update-by-secretariat';
import { MembersWithTeamValidation } from '../../models/members-with-team-validation';

export interface UpdateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch$Params {
  orgId: string;
  org: string;
      body: MembersUpdateBySecretariat
}

export function updateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch(http: HttpClient, rootUrl: string, params: UpdateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithTeamValidation>> {
  const rb = new RequestBuilder(rootUrl, updateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch.PATH, 'patch');
  if (params) {
    rb.path('orgId', params.orgId, {});
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembersWithTeamValidation>;
    })
  );
}

updateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch.PATH = '/api/v2/secretariat/members/{orgId}/profile';
